<!--information - basic info -->
<template>
  <div class="info-basic">
    <!-- Basic info -->
    <div>
      <h1>Basic info</h1>
      <ul class="ul-item dis-36">
        <li>
          <div>Name</div>
          <div>{{info.firstName + " " + info.lastName }}</div>
        </li>
        <li>
          <div>Email</div>
          <div>{{info.email}}</div>
        </li>
        <li>
          <div>Undergraduate year</div>
          <div>{{info.inYear}}</div>
        </li>
      </ul>
      <ul class="ul-item dis-36">
        <li>
          <div>CD Name</div>
          <div>{{info.cdName}}</div>
        </li>
        <li>
          <div>CD Email</div>
          <div>{{info.cdEmail}}</div>
        </li>
      </ul>
      <ul class="ul-item dis-36">
        <li>
          <div>Application year</div>
          <div>{{info.inYear}}</div>
        </li>
        <li>
          <div>Direction</div>
          <div>{{info.applyField}}</div>
        </li>
        <li>
          <div>Degree Level</div>
          <div>{{info.studyAbroadType | applyLevel}}</div>
        </li>
        <li>
          <div>Target school</div>
          <div>{{info.targetSchool}}</div>
        </li>
      </ul>
    </div>
    <!-- Package info -->
    <div class="dis-64">
      <h1>Package info</h1>
      <ul class="ul-item dis-24">
        <li>
          <div>Package Type</div>
          <div>{{info.packageName}}</div>
        </li>
        <li>
          <div>Number of application direction</div>
          <div>{{info.applyDirection}}</div>
        </li>
        <li>
          <div>Number of Program</div>
          <div>{{info.programCount}}</div>
        </li>
      </ul>
      <div class="red">
        Your time will not be remunerated if it exceeds the maximum allowance of a module.
      </div>
    </div>
    <!-- SM service info -->
    <div class="dis-96"
         v-if="userRole === 'SM'">
      <h2>SM service info</h2>
      <ul class="ul-item dis-40">
        <li>
          <div>Number of SM</div>
          <div>{{info.smCount}} (If the number of SM is greater than 1, mentee’s time is divided with other SM)</div>
        </li>
        <li>
          <div>Number of SM editing rounds</div>
          <div>{{info.essaySMRound}}</div>
        </li>
      </ul>
      <ul class="ul-item dis-40">
        <li>
          <div>
            <h3 class="dis-0"> Module 1-3</h3>
          </div>
          <div>&nbsp;</div>
        </li>
        <li>
          <div>Module 1-3 (Max time)</div>
          <div>{{menteeSchedule.zoomMax}} mins</div>
        </li>
        <li>
          <div>Module 1-3 (Used time)</div>
          <div>{{menteeSchedule.zoomUsed}} mins</div>
        </li>
        <li>
          <div>Module 1-3 (Remaining time)</div>
          <div>{{(menteeSchedule.zoomMax - menteeSchedule.zoomUsed)>=0?(menteeSchedule.zoomMax - menteeSchedule.zoomUsed): 0}} mins</div>
        </li>
      </ul>
      <ul class="ul-item dis-40">
        <li>
          <div>
            <h3 class="dis-0">Module 4</h3>
          </div>
          <div>&nbsp;</div>
        </li>
        <li>
          <div>Module 4 (Max time)</div>
          <div>{{menteeSchedule.editEssayMax}} mins</div>
        </li>
        <li>
          <div>Module 4 (Used time)</div>
          <div>{{menteeSchedule.editEssayUsed}} mins</div>
        </li>
        <li>
          <div>Module 4 (Remaining time)</div>
          <div>{{(menteeSchedule.editEssayMax - menteeSchedule.editEssayUsed)>=0?(menteeSchedule.editEssayMax - menteeSchedule.editEssayUsed): 0}} mins</div>
        </li>
      </ul>
      <ul class="ul-item">
        <li>
          <div>
            <h3 class="dis-0">Module 7</h3>
          </div>
          <div>&nbsp;</div>
        </li>
        <li>
          <div>Module 7 (Max time)</div>
          <div>{{menteeSchedule.csMax}} mins</div>
        </li>
        <li>
          <div>Module 7 (Used time)</div>
          <div>{{menteeSchedule.csUsed}} mins</div>
        </li>
        <li>
          <div>Module 7 (Remaining time)</div>
          <div>{{(menteeSchedule.csMax - menteeSchedule.csUsed)>=0?(menteeSchedule.csMax - menteeSchedule.csUsed): 0}} mins</div>
        </li>
      </ul>
    </div>
    <!-- EM service info -->
    <div class="dis-96"
         v-if="userRole === 'EM'">
      <h2>EM service info</h2>
      <ul class="ul-item dis-40">
        <li>
          <div>Number of EM</div>
          <div>{{info.emCount}}</div>
        </li>
      </ul>
      <ul class="ul-item dis-40">
        <li>
          <div>
            <h3 class="dis-0">Module 4</h3>
          </div>
          <div>&nbsp;</div>
        </li>
        <li>
          <div>Number of EM editing rounds</div>
          <div>{{info.essayEMRound}}</div>
        </li>
      </ul>
      <ul class="ul-item dis-40">
        <li>
          <div>Module 4 (Used time)</div>
          <div>{{menteeSchedule.editEssayUsed}} mins</div>
        </li>
      </ul>
      <ul class="ul-item dis-24">
        <li>
          <div>
            <h3 class="dis-0">Module 5</h3>
          </div>
          <div>&nbsp;</div>
        </li>
        <li>
          <div>Number of CV</div>
          <div>{{info.cvCount}}</div>
        </li>
        <li>
          <div>Number of EM editing rounds</div>
          <div>{{info.cvRound}}</div>
        </li>
      </ul>
      <ul class="ul-item dis-40">
        <li>
          <div>Module 5 (Used time)</div>
          <div>{{menteeSchedule.editCvUsed}} mins</div>
        </li>
      </ul>
      <ul class="ul-item dis-24">
        <li>
          <div>
            <h3 class="dis-0">Module 6</h3>
          </div>
          <div>&nbsp;</div>
        </li>
        <li>
          <div>Number of RL</div>
          <div>{{info.referrerCount}}</div>
        </li>
        <li>
          <div>Number of EM editing rounds</div>
          <div>{{info.rlRound}}</div>
        </li>
      </ul>
      <ul class="ul-item">
        <li>
          <div>Module 6 (Used time)</div>
          <div>{{menteeSchedule.editRlUsed}} mins</div>
        </li>
      </ul>
    </div>
    <div class="dis-96"
         v-if="userRole === 'CM'">
      <h2>CM service info</h2>
      <ul class="ul-item dis-36">
        <li>
          <div>Number of CM</div>
          <div>{{info.cmCount}} (If the number of CM is greater than 1, mentee’s time is divided with other CM)</div>
        </li>
      </ul>
      <ul class="ul-item dis-40">
        <li>
          <div>
            <h3 class="dis-0">Module 8</h3>
          </div>
          <div>&nbsp;</div>
        </li>
        <li>
          <div>Module 8 (Max time)</div>
          <div>{{menteeSchedule.csMax}} mins</div>
        </li>
        <li>
          <div>Module 8 (Used time)</div>
          <div>{{menteeSchedule.csUsed}} mins</div>
        </li>
        <li>
          <div>Module 8 (Remaining time)</div>
          <div>{{menteeSchedule.csMax-menteeSchedule.csUsed>=0?(menteeSchedule.csMax-menteeSchedule.csUsed):0}}mins</div>
        </li>
      </ul>
    </div>
    <template v-if="userRole === 'SM'">
      <div class="dis-64">
        <h2>Module 0</h2>
        <ul class="ul-item dis-24">
          <li>
            <div>Module 0 (Max time)</div>
            <div>60 mins</div>
          </li>
          <li>
            <div>Module 0 (Used time)</div>
            <div>{{menteeSchedule.module0}} mins</div>
          </li>
          <li>
            <div>Module 0 (Remaining time)</div>
            <div>{{(60-menteeSchedule.module0)>0?(60-menteeSchedule.module0) : 0}} mins</div>
          </li>
        </ul>
        <ul class="ul-item"
            v-if="60-menteeSchedule.module0">
          <li>
            <div>Time spent</div>
            <div>
              <Form ref="formValidate"
                    :model="formValidate"
                    :rules="ruleValidate">
                <FormItem label=""
                          prop="timeSpent">
                  <Input v-model="formValidate.timeSpent"></Input>
                </FormItem>
              </Form>
            </div>
          </li>
        </ul>
      </div>
      <div class="info-basic-btn"
           v-if="60-menteeSchedule.module0">
        <Button class="zlr-btn-primary"
                @click="handleConfirm"
                :loading="isSub">Confirm</Button>
      </div>
    </template>
  </div>
</template>

<script>
// API
import { getMenteeDetail } from '@/api/mentee'
import { getTimesheetSchedule, getTimesheetSaveModule } from '@/api/timesheet'
import { applyLevelMap, subSuc, promptInput } from '@/constant'
import { validateNumber } from '@/libs/validator'
import { mapState } from 'vuex'
export default {
  name: 'mentee-info-basic',
  components: {},
  data () {
    const validateMaxTime = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(promptInput))
      } else {
        let surplusTime = 60 - this.menteeSchedule.module0
        if (value > surplusTime) {
          callback(new Error(`Max time ${surplusTime}mins`))
        } else {
          callback()
        }
      }
    }
    return {
      info: {},
      menteeSchedule: {},
      formValidate: {},
      ruleValidate: {
        timeSpent: [{ required: true, message: promptInput }, { validator: validateNumber }, { validator: validateMaxTime }]
      },
      isSub: false
    }
  },
  computed: {
    ...mapState({
      userRole (state) {
        return state.user.userRole
      }
    })
  },
  mounted () {
    this.getMenteeBasicInfo()
    this.getTimesheetSchedule()
  },
  methods: {
    getMenteeBasicInfo () {
      let param = {
        num: this.$route.params.id
      }
      getMenteeDetail(param).then(res => {
        if (res.code === 0) {
          let data = res.data.model || {}
          this.info = Object.assign({}, data)
        }
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    // 学生进度
    getTimesheetSchedule () {
      getTimesheetSchedule({
        menteeNum: this.$route.params.id
      }).then(res => {
        this.menteeSchedule = res.data.model
      })
    },
    // 提交
    handleConfirm () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          this.isSub = true
          getTimesheetSaveModule({
            menteeNum: this.$route.params.id,
            timeSpent: this.formValidate.timeSpent
          }).then(res => {
            this.getTimesheetSchedule()
            this.$zlr_message(subSuc, 'success')
            this.$refs['formValidate'].resetFields()
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          }).thne(() => {
            this.isSub = false
          })
        } else {
          this.$Message.error('Fail!')
        }
      })
    }
  },
  filters: {
    applyLevel (value) {
      return applyLevelMap.get(value)
    }
  }
}
</script>
<style lang='less' scoped>
</style>
